
const API_URL =
  process.env.REACT_APP_API_URL;
    
export { API_URL };